import { render, staticRenderFns } from "./DeliveredRewards.vue?vue&type=template&id=6d557ec8"
import script from "./DeliveredRewards.vue?vue&type=script&lang=js"
export * from "./DeliveredRewards.vue?vue&type=script&lang=js"
import style0 from "./DeliveredRewards.vue?vue&type=style&index=0&id=6d557ec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports